<template>
    <ul :class="class_name">
        <li v-for="(data, index) of allServices" :key="index">
            <router-link :to="`/${module_data}/${data.slug}`">
                <i class="far fa-dot-circle" v-if="show_icon == 'true'"></i>
                <span class="category-text">{{ data.heading }}</span>
            </router-link>
        </li>        
    </ul>
</template>

<script>
export default {
    props: {
        services: Array,
        className: String,
        module: String,
        icon: String
    },
    data(){
        return {
            allServices:{},
            class_name: '',
            module_data: '',
            show_icon: ''
        }
    },
    created: function(){
        this.allServices = this.$props.services
        this.class_name = this.$props.className
        this.module_data = this.$props.module
        this.show_icon = this.$props.icon
    },
    watch: {
        "$props.services"(){
            this.allServices = this.$props.services
        }
    }
}
</script>